import React, { useEffect, useState } from "react";
import { makeStyles, Container, Grid } from "@material-ui/core";
import MetaSeo from "../../../components/MetaSeo";
import ScheduleComponent from "../../../components/MainComponent/ScheduleComponent";
import moment from "moment";
import ScheduleBoardComponent from "../../../components/MainComponent/ScheduleBoardComponent";

const useStyles = makeStyles((theme) => ({
  BoardTop: {
    paddingTop: "8rem",
    paddingBottom: "4rem",
    [theme.breakpoints.down("xs")]: {
      paddingTop: "4rem",
      paddingBottom: "2rem",
    },
  },

  sideZone: {
    paddingLeft: "6rem",
    paddingRight: "6rem",
    [theme.breakpoints.down("xs")]: {
      paddingLeft: 32,
      paddingRight: 32,
    },
  },
}));

interface BoardContainerProps {
  //   children: React.ReactNode | null | string | undefined;
  match: any;
  history: any;
}

function ScheduleTotalContainer({ match, history }: BoardContainerProps) {
  const classes = useStyles();
  const today = new Date();

  return (
    <Container maxWidth={false} className={classes.BoardTop} disableGutters>
      <Container
        maxWidth={"xl"}
        disableGutters={true}
        className={classes.sideZone}
      >
        <MetaSeo
          data={{
            title: "노동인권문화제 일정",
            description: "노동인권문화제 행사 일정입니다",
            canonical: "http://laborbusan.or.kr/schedule/total",
          }}
        />
        <Grid container>
          <Container>
            <Grid
              xs={12}
              item
              container
              // style={{ paddingLeft: "14rem", paddingRight: "14rem" }}
            >
              {/* <Grid xs={3} item>
              <ScheduleInput setMonth={setMonth} />
            </Grid> */}
              <Grid xs={12} item>
                <ScheduleBoardComponent match={match} history={history} />
              </Grid>
            </Grid>
          </Container>
        </Grid>
        {/* <BoardListGroup match={match} history={history} /> */}
      </Container>
    </Container>
  );
}

export default ScheduleTotalContainer;
